import React from "react";

var guideSvg = function guideSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.429 0h3.428C15.43 0 16 .5 16 1v13c0 .5-.571 1-1.143 1H9.732a2 2 0 0 1-3.464 0H1.143C.57 15 0 14.5 0 14V1c0-.5.571-1 1.143-1H4.57C5.461 0 6.35.404 7 1.002V13a1 1 0 0 0 2 0V1.002C9.65.404 10.54 0 11.429 0z",
    fillRule: "evenodd"
  }));
};

guideSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var guide = {
  category: 'icon',
  colorable: true,
  name: 'guide',
  svg: guideSvg
};